import React from 'react';
import Typed from 'react-typed';
import image from '../../Images/my pic.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCodeBranch, faLink } from '@fortawesome/free-solid-svg-icons';
import './Header.css';

const Header = () => {
    return (
        <main className="row d-flex header">
            <div className="intro col-md-8 col-12 col-sm-12">
                <div clasName="intro-text">
                    <p>Hello! I am</p>
                    <h1>Sudipta Acharjee</h1>
                    <h3>
                        <Typed
                            strings={['MERN Stack Developer', 'Programmer', 'Web Developer']}
                            typeSpeed={50}
                            backSpeed={50}
                            loop
                        />
                    </h3>
                    <div className="action">
                        <a className='btn' href="https://www.linkedin.com/in/sudipta-acharjee-8327b9169/" target="_blank"><FontAwesomeIcon icon={faLink} />Hire me</a>
                        <a className='btn' href="https://github.com/Sudipta-Acharjee" target="_blank"><FontAwesomeIcon icon={faCodeBranch} /> GitHub</a>
                    </div>
                </div>
            </div>
            <div className="col-md-4 col-sm-12 col-12 pic">
                <img className="img-fluid img-thumbnail" src={image}></img>
            </div>
        </main>
        // </div>
    );
};

export default Header;